angular.module('app.entity.crud', [
    'sharecrf-sdk',
]);
